// ROC (Taiwan) year conversion utilities

export function toROCYear(adYear) {
  return adYear - 1911;
}

export function toADYear(rocYear) {
  return rocYear + 1911;
}

export function formatROCDate(dateStr) {
  const d = new Date(dateStr);
  return `${toROCYear(d.getFullYear())}年${d.getMonth() + 1}月${d.getDate()}日`;
}

export function formatROCDateFull(dateStr) {
  const d = new Date(dateStr);
  const dayNames = ['日', '一', '二', '三', '四', '五', '六'];
  const dayOfWeek = dayNames[d.getDay()];
  return `民國${toROCYear(d.getFullYear())}年${d.getMonth() + 1}月${d.getDate()}日（${dayOfWeek}）`;
}

export function formatDate(dateStr, locale = 'zh-TW') {
  if (!dateStr) return '';

  const d = new Date(dateStr);

  if (locale === 'zh-TW') {
    return formatROCDate(dateStr);
  }

  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatDateShort(dateStr, locale = 'zh-TW') {
  if (!dateStr) return '';

  const d = new Date(dateStr);

  if (locale === 'zh-TW') {
    return `${toROCYear(d.getFullYear())}/${d.getMonth() + 1}/${d.getDate()}`;
  }

  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateStr, locale = 'zh-TW') {
  if (!dateStr) return '';

  const d = new Date(dateStr);

  if (locale === 'zh-TW') {
    const timeStr = d.toLocaleTimeString('zh-TW', {
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${formatROCDate(dateStr)} ${timeStr}`;
  }

  return d.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Local date as YYYY-MM-DD (toISOString would give the UTC date before 08:00 in Taiwan)
export function getToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getDayOfWeek(dateStr, locale = 'zh-TW') {
  const d = new Date(dateStr);

  if (locale === 'zh-TW') {
    const dayNames = ['週日', '週一', '週二', '週三', '週四', '週五', '週六'];
    return dayNames[d.getDay()];
  }

  return d.toLocaleDateString('en-US', { weekday: 'long' });
}

export function isWeekend(dateStr) {
  const d = new Date(dateStr);
  return d.getDay() === 0 || d.getDay() === 6;
}

export default {
  toROCYear,
  toADYear,
  formatROCDate,
  formatROCDateFull,
  formatDate,
  formatDateShort,
  formatDateTime,
  getToday,
  getDayOfWeek,
  isWeekend,
};
